jQuery(document).ready(() => {

	// Slider Aliados
	//////////////////////////////////////////////////////////////////////////////////////////

	jQuery('.aliados-slider').slick({
		infinite: true,
		slidesToShow: 6,
		slidesToScroll: 2,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
		dots: true,
		responsive: [
			{
				breakpoint: 1101,
				settings: {
					slidesToShow: 5
				}
			},
			{
				breakpoint: 993,
				settings: {
					slidesToShow: 6
				}
			},
			{
				breakpoint: 821,
				settings: {
					slidesToShow: 5
				}
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 649,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 577,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			}
		]
	});


	// Slider Noticias
	//////////////////////////////////////////////////////////////////////////////////////////
	jQuery('.noticias-slider').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
		dots: true,
		responsive: [
			{
				breakpoint: 1201,
				settings: {
					slidesToShow: 1,
				}
			},
			{
				breakpoint: 993,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 924,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	});

});